module.exports = __webpack_public_path__ + "media/czxp_gain.1f2719ce.wav";